import React, { useEffect, useState } from 'react'
import TopBar from '../../layouts/postLogin/TopBar'
import { TabsData } from '../../utils/TabsData'
import Tabs from '../sampleSize/Tabs'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ResearchReportDisplay } from './ResearchReportDisplay'
import { sampleData } from './sampleData'
import { getDeepSearchReport, getReportData } from './apiController'
import { setLoading } from '../../store/slices/auth'
import { CustomButton } from '../../widgets'
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons'
import {
  AiAgents,
  setAgentLoading,
  setAgentSuccess,
  setAgentError,
  selectAgentState,
} from '../../store/slices/aiAgentStatesSlice';
import { fetchUserCredits } from '../literatureSearch/apiController'
import NoUserCreditsModal from '../common/AiModuleComponents/NoUserCreditsModal'

interface ProjectData {
  TopicDesc: string;
  key_words: string[];
  id?: string; // Added for topic_id
  [key: string]: any; // For any other properties in project data
}

function DeepSearch() {
  const [report, setReport] = useState<any>(null);
  const [showReport, setShowReport] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [projectData, setProjectData] = useState<ProjectData | null>(null);
  const [action, setAction] = useState<string | null>(null);
  const [download, setDownload] = useState<boolean>(false);
  const [isCreditsAvailable, setIsCreditsAvailable] = useState<boolean>(true);
  const dispatch = useDispatch();

  const agentKey = AiAgents.DEEP_SEARCH;
  const agentState = useSelector(selectAgentState(agentKey));

  useEffect(() => {
    if (location.state) {
      let tempState = location.state as ProjectData;
      setProjectData(tempState);
      fetchReport(tempState);
    } else {
      navigate("/project");
    }
  }, []);

  async function checkUserCredits(tempState : any = null) {
    try {
      dispatch(setLoading(true));
      const aiAgents: any = JSON.parse(localStorage.getItem("aiAgents") || "[]");
      const deepSearchAgent = aiAgents?.find((agent) => agent.name === "Deep Search");
      const response: any = await fetchUserCredits(deepSearchAgent?.id, tempState?.TopicID || projectData?.TopicID);
      if (response?.status) {
        setIsCreditsAvailable(true);
        return true;
      } else {
        setIsCreditsAvailable(false);
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  }



  const fetchReport = async (tempState: ProjectData) => {
    try {
      dispatch(setAgentLoading(agentKey));
      const response = await getReportData(tempState?.TopicID);
      if (response?.data?.id !== "000000000000000000000000" && response?.data?.topic_id !== "") {
        setReport(response.data);
        setShowReport(true);
        dispatch(setAgentSuccess(agentKey));
      } else {
        setShowReport(false);
        dispatch(setAgentSuccess(agentKey));
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      dispatch(setAgentError(agentKey));
    }
  };

  const runDeepSearch = async () => {
    if (!projectData?.TopicID) return;
    const userCreditsAvailable = await checkUserCredits();
    if(!userCreditsAvailable){
      return;
    }
    try {
      dispatch(setAgentLoading(agentKey));
      // console.log(projectData)
      const aiAgents: any = JSON.parse(localStorage.getItem("aiAgents") || "[]");
      const deepSearchAgent = aiAgents?.find((agent) => agent.name === "Deep Search");
      const response = await getDeepSearchReport(projectData?.TopicID, deepSearchAgent?.id);
      setReport(response);
      setShowReport(true);
      dispatch(setAgentSuccess(agentKey));
    } catch (error) {
      console.error("Error doing deep search:", error);
      dispatch(setAgentError(agentKey));
    }
  };

  return (
    <>
      <div className="deepsearch-top-bar">
        <div className={window.innerWidth > 750 ? "page-header-style" : "page-header-data-style"}>
          <div className={window.innerWidth > 750 ? "project-title" : "project-title-mob"}>
            <ArrowLeftOutlined style={{ color: "#fff", fontSize: "36px", margin: "0px 10px" }} onClick={() => window.innerWidth > 750 ? navigate("/project") : navigate("/projectmobile")} />
            <div className="title">
              {projectData?.TopicDesc || projectData?.topicdesc}
            </div>
          </div>
          <div className='download-icon' onClick={() => setDownload(true)}>
            <DownloadOutlined />
          </div>
        </div>
      </div>
      <Tabs
        data={TabsData}
        selectedTab={1}
        projectData={projectData}
      />
      <div className='deep-search-button-container'>
        <CustomButton
          type="primary"
          isDisabled={agentState.isLoading || !isCreditsAvailable}
          loading={agentState.isLoading}
          text={showReport ? 'Re‑initiate DeepSearch' : 'Initiate DeepSearch'}
          onClick={runDeepSearch}
        />
      </div>
      {
        isCreditsAvailable === false &&
        <NoUserCreditsModal />
      }
      {showReport && <div className='deep-search-container'>
        <ResearchReportDisplay reportData={report} download={download} setDownload={setDownload} />
      </div>}
    </>

  );
}


export default DeepSearch;